import { PERMISSIONS } from '../constants/permissions.js';
import { ROLES } from '../constants/role';

import AdministrationDevices from '../views/pages/Administration/Devices';
import AdministrationTables from '../views/pages/Administration/Tables/index.jsx';
import AdministrationUsers from '../views/pages/Administration/Users/index.jsx';
import Analytics from '../views/pages/Analytics';
import Animal from '../views/pages/Animal';
import Animals from '../views/pages/Animals';
import Breeding from '../views/pages/Breeding';
import ContactUs from '../views/pages/ContactUs/index.jsx';
import Dashboard from '../views/pages/Dashboard';
import EditGateway from '../views/pages/EditGateway/index.jsx';
import EditTag from '../views/pages/EditTag/index.jsx';
import Farm from '../views/pages/Farm';
import Gateway from '../views/pages/Gateway';
import Geofence from '../views/pages/Geofence/index';
import Grazing from '../views/pages/Grazing';
import Group from '../views/pages/Group';
import Labels from '../views/pages/Groups';
import Maps from '../views/pages/Maps';
import Measurements from '../views/pages/Measures';
import NewAnimal from '../views/pages/NewAnimal';
import NewFarm from '../views/pages/NewFarm';
import GeofenceNew from '../views/pages/NewGeofence/index';
import NewGroup from '../views/pages/NewGroup';
import NewUser from '../views/pages/NewUser/index.jsx';
import Notifications from '../views/pages/Notifications';
import MyPlanner from '../views/pages/Planner';
import Profile from '../views/pages/Profile';
import Rule from '../views/pages/Rule';
import RuleBuilder from '../views/pages/RuleBuilder';
import Rules from '../views/pages/Rules';
import Site from '../views/pages/Site';
import Tag from '../views/pages/Tag';
import Devices from '../views/pages/devices';
import Notification from '../views/pages/notification.jsx';
import Tracking from '../views/pages/tracking.jsx';
import Treatment from '../views/pages/treatment.jsx';

const ThemeRoutes = [
  {
    path: '/farms/new',
    name: 'Farm',
    icon: 'mdi mdi-view-dashboard',
    features: ['farms'],
    component: NewFarm,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.FARMS.CREATE]
  },
  {
    path: '/farms/:id',
    name: 'Farm',
    icon: 'mdi mdi-view-dashboard',
    features: ['farms'],
    component: Farm,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.FARMS.VIEW]
  },
  {
    path: '/sites/:id',
    name: 'Site',
    icon: 'mdi mdi-view-dashboard',
    features: ['sites'],
    component: Site,
    display: false,
    protected: true,
    permissions: [PERMISSIONS.SITES.VIEW_OWN]
  },
  {
    path: '/pastures/new',
    name: 'GeofenceNew',
    icon: 'mdi mdi-view-dashboard',
    features: ['geofences'],
    component: GeofenceNew,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.GEOFENCES.CREATE]
  },
  {
    path: '/pastures/:id',
    name: 'Geofence',
    icon: 'mdi mdi-view-dashboard',
    features: ['geofences'],
    component: Geofence,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.GEOFENCES.VIEW_OWN]
  },
  {
    path: '/notification/:id',
    name: 'Notification',
    icon: 'mdi mdi-view-dashboard',
    features: ['notifications'],
    component: Notification,
    display: false,
    protected: true,
    permissions: [PERMISSIONS.NOTIFICATIONS.VIEW_OWN]
  },
  {
    path: '/group/new',
    name: 'Group',
    icon: 'mdi mdi-view-dashboard',
    features: ['groups'],
    component: NewGroup,
    display: false,
    protected: true,
    permissions: [PERMISSIONS.LABELS.CREATE]
  },
  {
    path: '/group/:id',
    name: 'Group',
    icon: 'mdi mdi-view-dashboard',
    features: ['groups'],
    component: Group,
    display: false,
    protected: true,
    permissions: [PERMISSIONS.LABELS.VIEW_OWN]
  },
  {
    path: '/rule/:id',
    name: 'Rule',
    icon: 'mdi mdi-view-dashboard',
    features: ['rules'],
    component: Rule,
    display: false,
    protected: true,
    permissions: [PERMISSIONS.RULES.VIEW_OWN]
  },
  {
    path: '/gateway/:id',
    name: 'Gateway',
    icon: 'mdi mdi-view-dashboard',
    features: ['gateways'],
    component: Gateway,
    display: false,
    protected: true,
    permissions: [PERMISSIONS.GATEWAYS.VIEW_OWN]
  },
  {
    path: '/tag/:id',
    name: 'Tag',
    icon: 'mdi mdi-view-dashboard',
    features: ['tags'],
    component: Tag,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.TAGS.VIEW_OWN]
  },
  {
    path: '/animals/new',
    name: 'LivestockNew',
    icon: 'mdi mdi-view-dashboard',
    features: ['livestock'],
    component: NewAnimal,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.ANIMALS.CREATE]
  },
  {
    path: '/animals/:id/:type',
    name: 'Livestock',
    icon: 'mdi mdi-view-dashboard',
    features: ['livestock'],
    component: Animal,
    protected: true,
    display: false
  },
  {
    path: '/animals/:id',
    name: 'Livestock',
    icon: 'mdi mdi-view-dashboard',
    features: ['livestock'],
    component: Animal,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.ANIMALS.VIEW_OWN]
  },

  /* DISPLAY MENU ITEMS */
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: 'mdi mdi-chart-arc',
    features: ['weather', 'calendar', 'tasks'],
    component: Dashboard,
    protected: true,
    roles: [ROLES.KEEPER.value, ROLES.ADMIN.value, ROLES.OWNER.value, ROLES.EMPLOYEE.value]
  },
  {
    path: '/maps',
    name: 'Maps',
    icon: 'mdi mdi-vector-square',
    features: ['weather', 'calendar', 'tasks'],
    component: Maps,
    protected: true,
    permissions: [PERMISSIONS.FARMS.VIEW, PERMISSIONS.SITES.VIEW_OWN, PERMISSIONS.LIVESTOCK_ACTIVITY.VIEW]
  },
  {
    path: '/tracking/:id',
    name: 'Track Livestock',
    icon: 'stf stf-track',
    component: Tracking,
    features: ['track_livestock'],
    protected: true,
    display: false
  },
  {
    path: '/planner',
    name: 'Planner',
    features: ['tasks', 'calendar'],
    icon: 'mdi mdi-format-list-bulleted',
    protected: true,
    component: MyPlanner
  },
  {
    path: '/notifications',
    name: 'Notifications',
    icon: 'mdi mdi-bell-outline',
    features: ['notifications'],
    component: Notifications,
    display: true,
    protected: true,
    permissions: [PERMISSIONS.NOTIFICATIONS.VIEW_OWN]
  },
  {
    collapse: true,
    path: '/animals',
    name: 'Livestock',
    icon: 'mdi mdi-cow',
    features: ['livestock'],
    component: Animals,
    protected: true,
    display: true,
    permissions: [
      PERMISSIONS.ANIMALS.VIEW_OWN,
      PERMISSIONS.LIVESTOCK_MEASURES.VIEW_OWN,
      PERMISSIONS.LIVESTOCK_BREEDING.VIEW_OWN,
      PERMISSIONS.LIVESTOCK_TREATMENT.VIEW_OWN
    ],
    children: [
      {
        path: '/animals',
        name: 'Livestock',
        mini: 'B',
        icon: 'mdi mdi-adjust',
        features: ['livestock'],
        protected: true,
        component: Animals,
        permissions: [PERMISSIONS.ANIMALS.VIEW_OWN]
      },
      {
        path: '/measures',
        name: 'Measures',
        mini: 'B',
        icon: 'mdi mdi-adjust',
        features: ['measures'],
        protected: true,
        component: Measurements,
        permissions: [PERMISSIONS.LIVESTOCK_MEASURES.VIEW_OWN]
      },
      {
        path: '/breeding',
        name: 'Breeding',
        mini: 'B',
        icon: 'mdi mdi-adjust',
        features: ['breeding'],
        protected: true,
        component: Breeding,
        permissions: [PERMISSIONS.LIVESTOCK_BREEDING.VIEW_OWN]
      },
      {
        path: '/treatments',
        name: 'Treatments',
        features: ['treatment'],
        icon: 'mdi mdi-adjust',
        protected: true,
        component: Treatment,
        permissions: [PERMISSIONS.LIVESTOCK_TREATMENT.VIEW_OWN]
      }
    ]
  },
  {
    path: '/groups',
    name: 'Groups',
    icon: 'mdi mdi-label-outline',
    features: ['groups'],
    component: Labels,
    display: true,
    protected: true,
    permissions: [PERMISSIONS.LABELS.VIEW_OWN]
  },
  {
    path: '/grazing',
    name: 'Grazing',
    icon: 'mdi mdi-barley',
    features: ['grazing'],
    component: Grazing,
    display: true,
    protected: true,
    permissions: [PERMISSIONS.GEOFENCES.VIEW_OWN]
  },
  {
    path: '/analytics',
    name: 'Analytics',
    icon: 'mdi mdi-poll',
    features: ['analytics'],
    component: Analytics,
    protected: true
  },
  {
    path: '/rules/builder/:id',
    name: 'RuleBuilder',
    features: ['rules'],
    icon: 'stf stf-rules',
    component: RuleBuilder,
    display: false,
    protected: true
  },
  {
    path: '/rules',
    name: 'Rules',
    features: ['rules'],
    icon: 'mdi mdi-clipboard-outline',
    component: Rules,
    display: true,
    protected: true,
    permissions: [PERMISSIONS.RULES.VIEW_OWN]
  },
  {
    path: '/devices',
    name: 'Devices',
    features: ['tags', 'gateways'],
    icon: 'mdi mdi-access-point',
    component: Devices,
    protected: true,
    permissions: [PERMISSIONS.TAGS.VIEW_OWN, PERMISSIONS.GATEWAYS.VIEW_OWN]
  },
  // Do not move rule builder as it must be the first to match

  // DO NOT DISPLAY
  {
    path: '/profile',
    name: 'Profile',
    icon: 'mdi mdi-view-dashboard',
    features: ['default'],
    component: Profile,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.USERS.VIEW_OWN]
  },
  {
    path: '/contact-us',
    name: 'Contact us',
    icon: 'mdi mdi-view-dashboard',
    features: ['default'],
    component: ContactUs,
    protected: true,
    display: false
  },
  {
    path: '/administration/tag/:id',
    name: 'Administration Tag',
    icon: 'mdi mdi-view-dashboard',
    features: ['default'],
    component: EditTag,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.TAGS.VIEW_ALL]
  },
  {
    path: '/administration/gateway/:id',
    name: 'Administration Gateway',
    icon: 'mdi mdi-view-dashboard',
    features: ['default'],
    component: EditGateway,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.GATEWAYS.VIEW_ALL]
  },
  {
    collapse: true,
    path: '/administration',
    name: 'Administration',
    icon: 'mdi mdi-wrench',
    features: ['default'],
    component: AdministrationUsers,
    protected: true,
    display: true,
    permissions: [PERMISSIONS.USERS.VIEW_ALL, PERMISSIONS.TAGS.VIEW_ALL, PERMISSIONS.GATEWAYS.VIEW_ALL],
    children: [
      {
        path: '/administration/users',
        name: 'Users',
        icon: 'mdi mdi-adjust',
        features: ['default'],
        protected: true,
        component: AdministrationUsers,
        permissions: [PERMISSIONS.USERS.VIEW_ALL]
      },
      {
        path: '/administration/devices',
        name: 'Devices',
        icon: 'mdi mdi-adjust',
        protected: true,
        features: ['default'],
        component: AdministrationDevices,
        permissions: [PERMISSIONS.TAGS.VIEW_ALL, PERMISSIONS.GATEWAYS.VIEW_ALL]
      },
      {
        path: '/administration/tables',
        name: 'Tables',
        icon: 'mdi mdi-adjust',
        features: ['default'],
        protected: true,
        component: AdministrationTables
      }
    ]
  },
  {
    path: '/new-user',
    name: 'NewUser',
    icon: 'mdi mdi-view-dashboard',
    features: ['default'],
    component: NewUser,
    protected: true,
    display: false,
    permissions: [PERMISSIONS.USERS.CREATE]
  },
  {
    path: '/',
    pathTo: '/dashboard',
    name: 'Default redirect',
    features: ['default'],
    redirect: true
  },
];

export default ThemeRoutes;
